module.exports = __webpack_public_path__ + "static/2-bee55becaa120102e275dd5ab033afd6.jpg";